class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    const storedVal = sessionStorage.getItem('discount_applied');
    const button = document.querySelector('#discountCode');
      if(storedVal === 'true' && button){
        button.textContent = 'Applied';
        button.disabled = true;
        button.style.background = 'transparent';
        button.style.color = '#28a745';
        button.style.opacity = '1';
        button.style.fontWeight = '600';
      }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    this.querySelector('#DiscountDrawer')?.classList?.remove('active');
    this.querySelector('.drawer__inner')?.classList?.remove('overflow-hidden');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);





// // document.addEventListener('change', function(e) {
// //   if (e.target.matches('.quantity input, .cart__qty-input')) {
// //     // Cart data reload
// //     setTimeout(function(){ 
// //     fetch('/cart.js')
// //       .then(res => res.json())
// //       .then(cart => {
// //         console.log("Total Qty:", cart.item_count);
// //         if(cart.item_count == 2){
// //           smallFireworks(); 
// //            var audio = new Audio("https://cdn.shopify.com/s/files/1/0913/4768/1558/files/shopify_sale_sound.mp3?v=1755163504");
// //         audio.play().catch(function(e){
// //             console.log("Autoplay blocked:", e);
// //         });
// //         }

// //         if(cart.item_count == 3){
// //           smallFireworks(); 
// //            var audio = new Audio("https://cdn.shopify.com/s/files/1/0913/4768/1558/files/shopify_sale_sound.mp3?v=1755163504");
// //         audio.play().catch(function(e){
// //             console.log("Autoplay blocked:", e);
// //         });
// //         }
// //         // Example: किसी element में दिखाना
// //      //   document.querySelector('.cart-qty-count').textContent = cart.item_count;
// //       });
// //        }, 1000);
// //   }
// // });






// (function () {
//   const GIFT_VARIANT_ID = "51631216558358";
//   const HIGH_DISCOUNT = "nosepin7707@@!!ss2x!";
//   const LOW_DISCOUNT = "pure10";
//   const THRESHOLD = 3000;
//   const MANAGED_CODES = [HIGH_DISCOUNT.toLowerCase(), LOW_DISCOUNT.toLowerCase()];

//   let isProcessing = false;
//   let lastQty = null;

//   async function syncCart() {
//     if (isProcessing) return;
//     isProcessing = true;

//     try {
//       const cart = await fetch('/cart.js').then(r => r.json());

//       console.log("Cart Qty:", cart.item_count);
//       console.log("Discount codes:", cart.discount_codes);

//       const currentDiscount = cart.discount_codes?.find(d => d.applicable);
//       const currentCode = currentDiscount?.code?.toLowerCase() || null;
//       const isForeignDiscount = currentCode && !MANAGED_CODES.includes(currentCode);

//       const cartTotalWithoutGift = cart.items.reduce(
//         (total, item) => String(item.variant_id) === GIFT_VARIANT_ID
//           ? total
//           : total + (item.original_price * item.quantity),
//         0
//       );

//       const eligible = (cartTotalWithoutGift / 100) >= THRESHOLD;
//       const giftExists = cart.items.some(item => String(item.variant_id) === GIFT_VARIANT_ID);

//       // Desired state
//       const desiredCode = isForeignDiscount ? null : (eligible ? HIGH_DISCOUNT : LOW_DISCOUNT);
//       const needsDiscountChange = !isForeignDiscount && currentCode !== desiredCode.toLowerCase();
//       const needsGiftRemoval = giftExists && !eligible;
//       const needsGiftAdd = !giftExists && eligible;

//       if (needsDiscountChange || needsGiftRemoval || needsGiftAdd) {
//         if (needsDiscountChange || needsGiftRemoval) {
//           const body = {};
//           if (needsDiscountChange) body.discount = desiredCode;
//           if (needsGiftRemoval) body.updates = { [GIFT_VARIANT_ID]: 0 };

//           await fetch("/cart/update.js", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify(body),
//           });

//           if (!eligible) sessionStorage.removeItem("discount_applied");
//         }

//         if (needsGiftAdd) {
//           await fetch("/cart/add.js", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID }] }),
//           });
//         }

//         await refreshDawnCartDrawer({ openDrawer: false }); // silent, won't pop open
//       }

//       // Unrelated qty-based effects (fireworks/sound), independent of discount sync
//       if (cart.item_count !== lastQty) {
//         lastQty = cart.item_count;
//         if (cart.item_count == 2 || cart.item_count == 3) {
//           // smallFireworks();
//           // var audio = new Audio("...");
//           // audio.play().catch(e => console.log("Autoplay blocked:", e));
//         }
//       }
//     } catch (err) {
//       console.error("Cart sync failed:", err);
//     } finally {
//       isProcessing = false;
//     }
//   }

//   async function refreshDawnCartDrawer({ openDrawer = false } = {}) {
//     const drawer = document.querySelector('cart-drawer');
//     if (!drawer) return;

//     const originalOpen = drawer.open.bind(drawer);
//     if (!openDrawer) {
//       drawer.open = () => {};
//     }

//     const sections = drawer.getSectionsToRender().map(s => s.id);
//     const response = await fetch(`${window.Shopify.routes.root}cart?sections=${sections.join(',')}`);
//     const sectionData = await response.json();

//     drawer.renderContents({ sections: sectionData });

//     if (!openDrawer) {
//       setTimeout(() => { drawer.open = originalOpen; }, 50);
//     }
//   }

//   let debounceTimer = null;
//   function scheduleSync() {
//     clearTimeout(debounceTimer);
//     debounceTimer = setTimeout(syncCart, 200);
//   }

//   document.addEventListener('DOMContentLoaded', () => {
//     syncCart(); // correct any existing mismatch on page load

//     // Primary trigger: Dawn's own cart-update pub/sub (same one the discount widget uses)
//     if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
//       subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
//     }

//     // Fallback trigger: DOM mutation on the drawer, in case something updates
//     // the cart without publishing cartUpdate
//     const cartDrawer = document.querySelector('cart-drawer');
//     if (cartDrawer) {
//       const observer = new MutationObserver(scheduleSync);
//       observer.observe(cartDrawer, { childList: true, subtree: true });
//     }
//   });
// })();